import type { TagLayout } from "./types";

export const TagLayoutSvg = ({ layout }: { layout: TagLayout }) => (
	<svg
		viewBox={`0 0 ${layout.w} ${layout.h}`}
		width="100%"
		role="img"
		aria-label="Tag preview"
		style={{ display: "block", background: "#fff" }}
	>
		{layout.items.map((it) =>
			it.d ? (
				<path key={it.id} d={it.d} fill="black" />
			) : (
				<text
					key={it.id}
					x={it.ax}
					y={it.by}
					textAnchor={it.anchor}
					fontSize={it.size}
					textLength={it.tw}
					lengthAdjust="spacingAndGlyphs"
					fill={it.over ? "#d32f2f" : "black"}
					fontFamily="'Arial Narrow', Arial, Helvetica, sans-serif"
				>
					{it.s}
				</text>
			),
		)}
	</svg>
);
